export default __webpack_public_path__ + "static/1_normal-71884d244d4379305192910b50432aa3.png";